/**
 * ResponsivePagination
 */
import React from 'react';
import { Icon, Pagination, Menu } from 'semantic-ui-react';
import withMobileDialog from '@material-ui/core/withMobileDialog';

interface Props {
    fullScreen: boolean;
    activePage: number;
    onPageChange: Function;
    totalPages: number;
}

export class ResponsivePagination extends React.PureComponent<Props> {
    render() {
        const { fullScreen, activePage, totalPages, ...props } = this.props;
        if (fullScreen) {
            return (
                <Menu style={{ marginLeft: 15 }} icon compact>
                    <Menu.Item
                        disabled={!(activePage > 1)}
                        onClick={() => {
                            this.props.onPageChange(null, {
                                activePage: activePage - 1
                            });
                        }}
                    >
                        <Icon name="angle left" />
                    </Menu.Item>
                    <Menu.Item
                        disabled={!(activePage < totalPages)}
                        onClick={() => {
                            this.props.onPageChange(null, {
                                activePage: activePage + 1
                            });
                        }}
                    >
                        <Icon name="angle right" />
                    </Menu.Item>
                </Menu>
            );
        }
        return (
            <Pagination
                style={{ marginLeft: 15 }}
                // size="tiny"
                firstItem={{
                    content: <Icon name="angle double left" />,
                    icon: true
                }}
                lastItem={{
                    content: <Icon name="angle double right" />,
                    icon: true
                }}
                prevItem={{ content: <Icon name="angle left" />, icon: true }}
                nextItem={{ content: <Icon name="angle right" />, icon: true }}
                activePage={activePage}
                totalPages={totalPages}
                {...props}
            />
        );
    }
}

export default withMobileDialog()(ResponsivePagination);
